@if (initialized && camtImportsWidgetData) {

    <div class="grid">

        <div class="col-12">
            <div class="surface-0 border-round p-3 mb-3">
                <h5 class="mt-0 mb-2">CAMT-Importe</h5>
                <p class="text-600 text-sm mt-0 mb-3">
                    Prüfen Sie die CAMT-Importe dieses Kreditors, starten Sie einen manuellen Import
                    ausstehender Dokumente und spielen Sie als Duplikat markierte Importe forciert ein.
                </p>

                <div class="flex flex-wrap align-items-center gap-2 mb-2">
                    <p-button
                            label="Jetzt importieren"
                            icon="fa-solid fa-file-import"
                            [loading]="manualImportBusy"
                            (onClick)="importPendingDocuments()">
                    </p-button>

                    <p-button
                            label="Forciert importieren"
                            icon="fa-solid fa-file-circle-check"
                            severity="warn"
                            [loading]="forceImportBusy"
                            [disabled]="!canForceImportSelected()"
                            (onClick)="forceImportSelected()">
                    </p-button>
                </div>

                @if (selectedImport && !canForceImportSelected()) {
                    <p class="text-600 text-sm mt-0 mb-0">
                        Nur als Duplikat markierte Importe können forciert eingespielt werden.
                    </p>
                } @else if (!selectedImport) {
                    <p class="text-600 text-sm mt-0 mb-0">
                        Wählen Sie einen Duplikat-Eintrag aus der Tabelle, um ihn forciert zu importieren.
                    </p>
                }
            </div>
        </div>

        <div class="col-12">
            <mvs-widget
                    [widgetData]="camtImportsWidgetData"
                    (onObjectSelect)="handleObjectSelect($event)">
            </mvs-widget>
        </div>
    </div>

}
